import React from 'react'
import { useState } from 'react';
import axios from 'axios';
import "./Form.css"

const Form = () => {
    const[user , setUser] = useState({ name:'' , mobile: '' , address:''});  
    const { name , mobile ,address} = user;
    const inputChangeHandler= (e) => {
     setUser({...user , [e.target.name] :e.target.value });
 } 
   const submitHandler = async(e) =>{
      e.preventDefault();
      await axios.post(`http://localhost:3001/users` , user);
    /*await axios.post('https://my-json-server.typicode.com/RiyazSyed8790/mockjson/users/' , user);
    console.log(user);*/
    /*await axios.post(`https://github.com/RiyazSyed8790/mockjson/edit/main/db.json` , user);*/
   /*await fetch('https://my-json-server.typicode.com/RiyazSyed8790/mockjson/users', {
  method: 'POST',
  body: JSON.stringify({
    name: user.name,
    mobile: user.mobile,
    address: user.address,
  }),
  headers: {
    'Content-type': 'application/json; charset=UTF-8',
  },
})
  .then((response) => response.json())
  .then((json) => console.log(json));*/
   }
    return (
        <div className="container">
            <form onSubmit={(e) => submitHandler(e)}>
                  <h4>Name:</h4>
                 <input onChange={(e) => inputChangeHandler(e)} type="text" name="name" placeholder="Name"   />
                  <h4>Mobile No.:</h4>
                  <input onChange={(e) => inputChangeHandler(e)} type="text" name="mobile" placeholder="Mobile No."  />
                  <h4>Address:</h4>
                  <textarea onChange={(e) => inputChangeHandler(e)} name="address" placeholder="Enter your address"  ></textarea>
                  <p style={{color:'rgb(241, 38, 38)'}} >*Do not enter these without selecting any item!</p>
                  <button type="submit">Confirm</button>  
                </form>
        </div>
    )
}

export default Form
